import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Toast } from "@egovernments/digit-ui-react-components";
// import useDepartmentSelector from "../../../../TCPForms/hooks/useDepartmentSelector";

import { useHistory } from "react-router-dom";

import { getDocumentByFileStoreId } from "@egovernments/digit-ui-libraries/src/utils/fileType";
import { FaFilePdf } from "react-icons/fa";
import { useSelector } from "react-redux";
import SortingAlphabatically from "../../reusableComponents/SortingAlphbatically";
import { Grid } from "@mui/material";
import InputWrapper from "../../layout/inputWrapper";
import ButtonWrapper from "../../components/Button";
import RemarksEditor from "../../../../../../../templates/ApplicationDetails/components/EmpReusableComp/RemarksEditor";
import { natureOfConstruction, planOnOptions, statesName } from "../../../TCPForms/data";
import FileUploader from "../../reusableComponents/FileUploader2";
import { Col, Container, Row } from "react-bootstrap";

const WorkCommencementModule = ({
  formData,
  handleSubTabChange,
  userInfo,
  isEmployee = false,
  handleTabChange,
  setProposedSite,
  schemeTypeData,
  nonSchemeTypeData,
  id,
}) => {
  console.log("loggingFromEDCRPORTAL", nonSchemeTypeData, schemeTypeData);
  console.log(formData, "formDataFromWorkCommencementModule");
  const { t } = useTranslation();
  const [file, setFile] = useState(null);
  const tenantId = Digit.ULBService.getStateId();
  const { documents } = useSelector((state) => state.formMT);
  const history = useHistory();
  const inputWidth = 200;
  const checklist = formData?.landInfo?.checklistdata;
  const [error, setError] = useState("");
  const [remarks, setRemarks] = useState("");
  const defaultValues = {
    ...formData,
    fastPASId: formData?.fastPASId,
    proposalType: formData?.proposalType,
    isSpecialProject: formData?.isSpecialProject,
    groundCoverages: formData?.groundCoverages,
    fars: formData?.fars,
    buildingHeight: formData?.buildingHeight,
    previousSetbackFront: formData?.setbackFronts,
    previousSetbackRear: formData?.setbackRears,
    natureOfConstructionOptions: formData?.natureOfConstructionOptions,
  };
  const { handleSubmit, control, setValue, watch, reset, getValues } = useForm({ defaultValues });
  const { data: districtData, isLoading: isDistrictDataLoading } = Digit.Hooks.useTenants();
  const updistricts = !isDistrictDataLoading && districtData.filter((district) => !district.code?.includes("up"));
  const [fastPASData, setFastPasData] = useState(Digit?.SessionStorage.get("EMP_MAPSUB") || null);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [showToast, setShowToast] = useState(null);
  const { data, isLoading: isDropDataLoading } = Digit.Hooks.obps.useMDMS(tenantId, "MapSubmission", "DropdownsConfig");
  const dropDownData = !isDropDataLoading && data?.MapSubmission?.DropdownsConfig?.[0];
  const [schemeType, setSchemeType] = useState(false);
  const [dwgPdf, setDwgPdf] = useState(null);

  const [
    watchPlanOn,
    watchnatureOfConstruction,
    watchlandUseType,
    watchSubZoneType,
    watchPrimaryUse,
    watchAtivityProposed,
    watchLandMark,
    watchState,
  ] = watch([
    "planOn",
    "natureOfConstruction",
    "zoneType",
    "subZoneType",
    "primaryUse",
    "activityProposed",
    "landMark",
    "landInfo.owners.[0].correspondenceAddress.state",
  ]);

  useEffect(() => {
    if (watchnatureOfConstruction === "Revalidation/Time Extension") {
      history.push(`mapRevalidation`);
    }
  }, [watchnatureOfConstruction]);

  useEffect(() => {
    const alldocs = fastPASData?.documents;
    if (Array.isArray(alldocs) && Array.isArray(documents) && !isEmployee) {
      const mergedDocs = [...(alldocs || []), ...(documents || [])];
      setValue("documents", mergedDocs);
    }
    if (isEmployee) {
      setValue("documents", documents);
    }
  }, [documents]);

  const closeToast = () => {
    setShowToast(null);
  };
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 3000);
    return () => clearTimeout(timeOut);
  }, [showToast]);

  const handleSearchClick = async (fastPASId) => {
    try {
      let response;
      let data;
      const id = fastPASId.replace(/[-/]/g, "");
      if (fastPASId) {
        response = await Digit.OBPSService.BPAFastPASSearch({ land_Id: id });
        console.log(response, "responsefromFASTPAS");

        if (response?.BPA?.length === 0) {
          return;
        }
        data = response?.BPA?.[0];
        setFastPasData(data);
        const drawingPdfs = data?.documents?.filter((e) => e.documentType === "drawingPdf");
        setDwgPdf(drawingPdfs?.[0]?.fileStoreId);

        if (data) {
          setValue("zoneType", data?.descriptionOfLand?.landUsesType);
          setValue("primaryUse", data?.descriptionOfLand?.activityAsPerMap);
          setValue("landMark", data?.descriptionOfLand?.landMark);
          setValue("sectorNo", data?.descriptionOfLand?.sectorNo);
          setValue("khasraNo", data?.descriptionOfLand?.khasraWithArea[0]?.khasraNo);
          setValue("schemeName", data?.descriptionOfLand?.schemeName);
          setValue("natureOfConstruction", data?.natureOfConstruction);
          setValue("sanctionNumber", data?.sanctionNumber);
          setValue("sanctionDate", data?.sanctionDate);
          setValue("revenueVillage", data?.revenueVillage);
          setValue("landMark", data?.landMark);
          setValue("sectorNo", data?.sectorNo);
          setValue("khasraNo", data?.khasraNo);
          setValue("plotNo", data?.plotNo);
          setValue("descriptionOfLand.latitude", data?.descriptionOfLand?.latitude);
          setValue("descriptionOfLand.longitude", data?.descriptionOfLand?.longitude);
          setValue("descriptionOfLand.schemeType", data?.descriptionOfLand?.schemeType);
          setValue("schemeName", data?.descriptionOfLand?.schemeName);
          setValue("riskType", data?.riskType);
          setValue("planOn", "plinth_submission");
          setValue("selectedOffice", "Lucknow Development Authority");
          setValue("department", data?.department);
          setValue("businessService", "BPA_MAPPLINTH_DA");
          setValue("activityProposed", data?.descriptionOfLand?.activityProposed);
          setValue("plotArea", data?.descriptionOfLand?.landArea);
          setValue("plotAreaDoc", data?.descriptionOfLand?.plotAreaDoc);
          setValue("plotAreaPos", data?.descriptionOfLand?.plotAreaPossession);
          setValue("siteAddress", data?.descriptionOfLand?.landAddress);
          setValue("tehsil", data?.tehsil);
          setValue("typeOfArea", data?.descriptionOfLand?.developmentArea);
          setValue("subZoneType", data?.descriptionOfLand?.subLandUseAsPerLayout);

          setValue("professionaldetails.consultantCategory", data?.professionaldetails?.consultantCategory);
          setValue("professionaldetails.name", data?.professionaldetails?.name);
          setValue("professionaldetails.emailId", data?.professionaldetails?.emailId);
          setValue("professionaldetails.mobileNumber", data?.professionaldetails?.mobileNumber);
          setValue("professionaldetails.certificateNo", data?.professionaldetails?.certificateNo);
          setValue("professionaldetails.validupto", data?.professionaldetails?.validupto);

          setValue("landInfo.owners.[0].name", data?.professionaldetails?.consultantCategory);
          setValue("landInfo.owners.[0].name", data?.landInfo?.owners?.[0]?.name);
          setValue("landInfo.owners.[0].emailId", data?.landInfo?.owners?.[0]?.emailId);
          setValue("landInfo.owners.[0].mobileNumber", data?.landInfo?.owners?.[0]?.mobileNumber);
          setValue("landInfo.owners.[0].correspondenceAddress.state", data?.landInfo?.owners?.[0]?.correspondenceAddress?.state);
          setValue("landInfo.owners.[0].correspondenceAddress.town", data?.landInfo.owners?.[0]?.correspondenceAddress?.town);
          setValue("landInfo.owners.[0].correspondenceAddress.pinno", data?.landInfo.owners?.[0]?.correspondenceAddress?.pinno);
          setValue("landInfo.owners.[0].correspondenceAddress.address", data?.landInfo.owners?.[0]?.correspondenceAddress?.address);

          setValue("blocks.[0].setBacks.[0].frontYard.minimumDistance", data?.blocks?.[0]?.setBacks?.[0]?.frontYard?.minimumDistance);
          setValue("blocks.[0].setBacks.[0].rearYard.minimumDistance", data?.blocks?.[0]?.setBacks?.[0]?.rearYard?.minimumDistance);
          setValue("blocks.[0].setBacks.[0].sideYard1.minimumDistance", data?.blocks?.[0]?.setBacks?.[0]?.sideYard1?.minimumDistance);
          setValue("blocks.[0].setBacks.[0].sideYard2.minimumDistance", data?.blocks?.[0]?.setBacks?.[0]?.sideYard2?.minimumDistance);

          setValue("blocks.[0].setBacks.[1].frontYard.minimumDistance", data?.blocks?.[0]?.setBacks?.[1]?.frontYard?.minimumDistance);
          setValue("blocks.[0].setBacks.[1].rearYard.minimumDistance", data?.blocks?.[0]?.setBacks?.[1]?.rearYard?.minimumDistance);
          setValue("blocks.[0].setBacks.[1].sideYard1.minimumDistance", data?.blocks?.[0]?.setBacks?.[1]?.sideYard1?.minimumDistance);
          setValue("blocks.[0].setBacks.[1].sideYard2.minimumDistance", data?.blocks?.[0]?.setBacks?.[1]?.sideYard2?.minimumDistance);

          setValue("landInfo.checklistdata.plinthHeight", data?.blocks?.[0]?.plinthHeight?.[0]);

          const isApproved = data?.descriptionOfLand?.schemeType === "Scheme";
          setSchemeType(isApproved);
        }
      }
    } catch (error) {
      console.error("Error occurred:", error);
    }
  };
  const filterSchemeData = (authority, masterData, category, subCategory) => {
    // First, find the relevant data once and store it
    const authorityData = masterData?.find((item) => item.name === authority);

    if (!authorityData) return { landUseList: [], landSubUseList: null }; // Return early if no authority data is found

    // Calculate landUseList, which doesn't depend on category
    const landUseList =
      authorityData?.LandUse?.map((item) => ({
        name: item.Type,
        value: item.Type,
      })) || []; // Fallback to an empty array if no LandUse is found

    let landSubUseList = null;

    // Only calculate landSubUseList if category is provided
    if (category) {
      const landUseCategory = authorityData?.LandUse?.find((item) => item.Type === category);

      // Only process if the specific category is found
      if (landUseCategory) {
        landSubUseList =
          landUseCategory.LandSubUse?.map((item) => ({
            name: item,
            label: item,
          })) || []; // Fallback to empty array if LandSubUse is not found
      }
    }

    console.log("loggingMasterData", landUseList, landSubUseList);

    return { landUseList, landSubUseList };
  };

  const filterNonSchemeData = (authority, masterData, category, subCategory) => {
    console.log("FromNonschemeDataCalled", masterData, category);

    const landUseList = masterData?.[0]?.CategeryType?.map((item) => {
      return { name: item.Categery, label: item.Categery };
    });
    const landSubUseList = masterData?.[0]?.CategeryType?.filter((item) => item.Categery === category)?.[0]?.["Activity Proposed"]?.map((item) => {
      return { name: item, label: item };
    });

    console.log("NonschemeDataCalled");
    console.log("nonSchemList", landUseList, landSubUseList);
    return { landUseList, landSubUseList };
  };
  const { landUseList, landSubUseList } = !schemeType
    ? filterSchemeData(fastPASData?.selectedOffice, schemeTypeData, watchlandUseType, watchSubZoneType)
    : filterNonSchemeData(fastPASData?.selectedOffice, nonSchemeTypeData, watchlandUseType, watchSubZoneType);

  const onSubmit = (data) => {
    const final = { ...fastPASData, ...data };
    if (isEmployee) {
      handleTabChange(2, final);
    } else {
      data.khasraRemarks = remarks;
      handleTabChange(1, final);
    }
  };
  return (
    <section className="formContainer">
      {/* Main Header - Add this code */}

      <div className="formHeaderContainer">
        <h2 className="formHeading">{t("Work Commencement Module)")}</h2>
      </div>
      <section className="groupContainer2">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="formContainer">
            <Container fluid className="formInputContainer common-app-form">
              <Row>
                <Col>
                  <InputWrapper
                    control={control}
                    label="FASTPAS ID"
                    placeholder="Enter FASTPAS ID"
                    name="fastPASId"
                    type="textInput"
                    mandatory
                    defaultValue={formData?.fastPASId}
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    disabled={isEmployee}
                    showSearchIcon={true}
                    onSearchClick={() => handleSearchClick(getValues("fastPASId"))}
                  />
                </Col>
                <Col></Col>
              </Row>
            </Container>
          </div>

          <div className="formContainer">
            <div className="formHeaderContainer">
              <h2 className="formHeading">{t("Licensed Technical Person (LTP)")}</h2>
            </div>
            <Container fluid className="formInputContainer common-app-form">
              <Row>
                <Col>
                  <InputWrapper
                    control={control}
                    label={`${t("Consultant Category")}`}
                    placeholder={`${t("Cosultant Category")}`}
                    name="professionaldetails.consultantCategory"
                    defaultValue={formData?.professionaldetails?.consultantCategory}
                    type="textInput"
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    disabled={isEmployee}
                  />
                </Col>
                <Col>
                  {" "}
                  <InputWrapper
                    label={t("LABEL_APPLICANT_NAME")}
                    control={control}
                    placeholder={t("LABEL_ENTER_NAME")}
                    name="professionaldetails.name"
                    mandatory
                    maxLength={15}
                    defaultValue={formData?.professionaldetails?.name}
                    type="textInput"
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                      pattern: {
                        value: Digit.Utils.getPattern("Name"),
                        message: "Please enter only letters and spaces",
                      },
                    }}
                    disabled={isEmployee}
                  />
                </Col>
              </Row>

              <Row>
                <Col>
                  {" "}
                  <InputWrapper
                    label={t("LABEL_EMAIL_ID")}
                    control={control}
                    placeholder={t("LABEL_ENTER_APPLICANT_EMAIL_ID")}
                    name="professionaldetails.emailId"
                    defaultValue={formData?.professionaldetails?.emailId}
                    type="textInput"
                    mandatory
                    maxLength={25}
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                      pattern: {
                        value: Digit.Utils.getPattern("Email"),
                        message: "Please enter valid email id",
                      },
                    }}
                    disabled={isEmployee}
                  />
                </Col>
                <Col>
                  {" "}
                  <InputWrapper
                    label={t("Enter Mobile No")}
                    control={control}
                    placeholder={t("Mobile No")}
                    mobileNumber
                    mandatory
                    type="textInput"
                    name="professionaldetails.mobileNumber"
                    defaultValue={formData?.professionaldetails?.mobileNumber}
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                      pattern: {
                        value: Digit.Utils.getPattern("MobileNo"),
                        message: "Please enter valid mobile no",
                      },
                    }}
                    maxLength={10}
                    disabled={isEmployee}
                  />
                </Col>
              </Row>

              <Row>
                <Col>
                  {" "}
                  <InputWrapper
                    label="Certificate No. (For Minimum Qualification)"
                    control={control}
                    placeholder="Enter Certificate No"
                    maxLength={13}
                    type="textInput"
                    name="professionaldetails.certificateNo"
                    defaultValue={formData?.professionaldetails?.certificateNo}
                  />
                </Col>
                <Col>
                  {" "}
                  <InputWrapper
                    label={t("LABEL_VALID_UPTO")}
                    control={control}
                    placeholder="Select Date"
                    type="datePicker"
                    name="professionaldetails.validupto"
                    defaultValue={formData?.professionaldetails?.validupto}
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
              </Row>
            </Container>
          </div>

          <div className="formContainer">
            <div className="formHeaderContainer">
              <h2 className="formHeading">{t("Owner Information")}</h2>
            </div>
            <Container fluid className="formInputContainer common-app-form">
              <Row>
                <Col>
                  {" "}
                  <InputWrapper
                    label={t("Name")}
                    control={control}
                    placeholder={t("LABEL_ENTER_NAME")}
                    name="landInfo.owners.[0].name"
                    mandatory
                    maxLength={15}
                    defaultValue={formData?.landInfo?.owners?.[0]?.name}
                    type="textInput"
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                      pattern: {
                        value: Digit.Utils.getPattern("Name"),
                        message: "Please enter only letters and spaces",
                      },
                    }}
                    disabled={isEmployee}
                  />
                </Col>
                <Col>
                  {" "}
                  <InputWrapper
                    label={t("Enter Mobile No")}
                    control={control}
                    placeholder={t("Mobile No")}
                    mobileNumber
                    mandatory
                    type="textInput"
                    name="landInfo.owners.[0].mobileNumber"
                    defaultValue={formData?.landInfo?.owners?.[0]?.mobileNumber}
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                      pattern: {
                        value: Digit.Utils.getPattern("MobileNo"),
                        message: "Please enter valid mobile no",
                      },
                    }}
                    maxLength={10}
                    disabled={isEmployee}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <InputWrapper
                    label={t("LABEL_EMAIL_ID")}
                    control={control}
                    placeholder={t("LABEL_ENTER_APPLICANT_EMAIL_ID")}
                    name="landInfo.owners.[0].emailId"
                    defaultValue={formData?.landInfo?.owners?.[0]?.emailId}
                    type="textInput"
                    mandatory
                    maxLength={25}
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                      pattern: {
                        value: Digit.Utils.getPattern("Email"),
                        message: "Please enter valid email id",
                      },
                    }}
                    disabled={isEmployee}
                  />
                </Col>
                <Col>
                  <InputWrapper
                    control={control}
                    label={t("LABEL_STATE")}
                    placeholder={t("LABEL_ENTER_STATE")}
                    name="landInfo.owners.[0].correspondenceAddress.state"
                    defaultValue={formData?.landInfo?.owners?.[0]?.correspondenceAddress?.state}
                    type="selectInput"
                    data={statesName}
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    disabled={isEmployee}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <InputWrapper
                    control={control}
                    data={updistricts}
                    label={t("LABEL_CITY")}
                    placeholder={watchState === "Uttar Pradesh" ? "Select District" : t("LABEL_ENTER_CITY")}
                    name="landInfo.owners.[0].correspondenceAddress.town"
                    defaultValue={formData?.landInfo?.owners?.[0]?.correspondenceAddress?.town}
                    type={watchState === "Uttar Pradesh" ? "selectInput" : "textInput"}
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    disabled={isEmployee}
                  />
                </Col>
                <Col>
                  <InputWrapper
                    control={control}
                    label={t("LABEL_PINCODE")}
                    placeholder={t("LABEL_ENTER_PINCODE")}
                    name="landInfo.owners.[0].correspondenceAddress.pinno"
                    defaultValue={formData?.landInfo?.owners?.[0]?.correspondenceAddress?.pinno}
                    type="textInput"
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                      pattern: {
                        value: Digit.Utils.getPattern("Pincode"),
                        message: "Please enter valid Pincode",
                      },
                    }}
                    maxLength={6}
                    disabled={isEmployee}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  {" "}
                  <InputWrapper
                    control={control}
                    label={t("LABEL_ADDRESS")}
                    placeholder={t("LABEL_ENTER_ADDRESS")}
                    name="landInfo.owners.[0].correspondenceAddress.address"
                    defaultValue={formData?.landInfo?.owners?.[0]?.correspondenceAddress?.address}
                    type="textInput"
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                      pattern: {
                        value: Digit.Utils.getPattern("Address"),
                        message: "Please enter valid Address",
                      },
                    }}
                    maxLength={50}
                    disabled={isEmployee}
                  />
                </Col>
                <Col></Col>
              </Row>
            </Container>
          </div>

          <div className="formContainer">
            <div className="formHeaderContainer">
              <h2 className="formHeading">{t("Plot Details")}</h2>
            </div>
            <Container fluid className="formInputContainer common-app-form">
              <Row>
                <Col>
                  <InputWrapper
                    control={control}
                    data={SortingAlphabatically(landUseList)}
                    label={t("Land Use")}
                    placeholder={t("Select Type of Land")}
                    name="zoneType"
                    defaultValue={formData?.zoneType}
                    type="selectInput"
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    disabled={isEmployee}
                  />
                </Col>
                <Col>
                  <InputWrapper
                    control={control}
                    data={SortingAlphabatically(landSubUseList)}
                    label={t("Land Sub Use")}
                    placeholder={t("Select Type of Land Subuse")}
                    name="subZoneType"
                    defaultValue={formData?.descriptionOfLand?.subLandUseAsPerLayout || formData?.subZoneType}
                    type="selectInput"
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    disabled={isEmployee}
                  />
                </Col>
              </Row>

              <Row>
                <Col>
                  <InputWrapper
                    control={control}
                    data={SortingAlphabatically(landUseList)}
                    label={t("Primary Use of Proposed Activity")}
                    placeholder={t("Select Primary Use of Proposed Activity")}
                    name="primaryUse"
                    defaultValue={formData?.primaryUse}
                    type="selectInput"
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    disabled={isEmployee}
                  />
                </Col>
                <Col>
                  <InputWrapper
                    control={control}
                    data={SortingAlphabatically(landSubUseList)}
                    label={t("Activity proposed")}
                    placeholder={t("Select Type of Activity proposed")}
                    name="activityProposed"
                    defaultValue={formData?.activityProposed}
                    type="selectInput"
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    disabled={isEmployee}
                  />
                </Col>
              </Row>

              <Row>
                <Col>
                  {" "}
                  <InputWrapper
                    control={control}
                    data={SortingAlphabatically(planOnOptions)}
                    label={t("Proposed Site")}
                    placeholder={t("Proposed Site")}
                    name="proposalType"
                    defaultValue={formData?.proposalType}
                    type="selectInput"
                    disabled={isEmployee}
                  />
                </Col>
                {watchPlanOn === "Others" ? (
                  <Col>
                    <InputWrapper
                      label={"Other Proposed Site"}
                      control={control}
                      placeholder={t("Enter Proposed Site")}
                      name="otherSchemeName"
                      mandatory
                      defaultValue={formData?.otherSchemeName}
                      type="textInput"
                      disabled={isEmployee}
                    />
                  </Col>
                ) : (
                  <Col></Col>
                )}
              </Row>

              <Row>
                <Col>
                  <InputWrapper
                    label={t("Sanction No.")}
                    control={control}
                    placeholder={t("Enter sanction number")}
                    name="layoutsanctionNumber"
                    defaultValue={formData?.layoutsanctionNumber}
                    type="textInput"
                    disabled={isEmployee}
                  />
                </Col>
                <Col>
                  <InputWrapper
                    label={t("Sanction Date")}
                    control={control}
                    placeholder={t("Enter Sanction date")}
                    name="layoutsanctionDate"
                    defaultValue={formData?.layoutsanctionDate}
                    type="datePicker"
                    disabled={isEmployee}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <InputWrapper
                    control={control}
                    label={t("Nature of Construction /Case Type")}
                    placeholder={t("Select Nature Of Construction")}
                    name="natureOfConstruction"
                    defaultValue={formData?.natureOfConstruction}
                    data={SortingAlphabatically(natureOfConstruction)}
                    type="selectInput"
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    disabled={isEmployee}
                  />
                </Col>

                <Col>
                  <InputWrapper
                    label={t("Validity")}
                    control={control}
                    placeholder={t("Select Validity")}
                    name="validity"
                    mandatory
                    maxLength={15}
                    defaultValue={formData?.validity}
                    type="datePicker"
                    disabled={isEmployee}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <InputWrapper
                    label="Scheme Name"
                    control={control}
                    placeholder="Select Scheme Name"
                    defaultValue={formData?.schemeName}
                    name={`schemeName`}
                    type="selectInput"
                    mandatory
                    data={SortingAlphabatically(dropDownData?.schemeName)}
                    disabled={isEmployee}
                  />
                </Col>
                <Col>
                  <InputWrapper
                    label="Tehsil"
                    control={control}
                    placeholder="Enter Tehsil"
                    defaultValue={formData?.tehsil}
                    name={`tehsil`}
                    type="textInput"
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    disabled={isEmployee}
                  />
                </Col>
              </Row>

              <Row>
                <Col>
                  <InputWrapper
                    label="Revenue Village/Colony Name"
                    control={control}
                    placeholder="Enter Revenue Village"
                    defaultValue={formData?.revenueVillage}
                    name={`revenueVillage`}
                    type="textInput"
                  />
                </Col>
                <Col>
                  <InputWrapper
                    label={t("Land Mark")}
                    control={control}
                    placeholder={t("Enter Land Mark")}
                    name="landMark"
                    maxLength={15}
                    defaultValue={formData?.landMark}
                    type="textInput"
                    disabled={isEmployee}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <InputWrapper
                    label={t("Sector/Pocket No.")}
                    control={control}
                    placeholder={t("Enter Sector/Pocket No.")}
                    name="sectorNo"
                    maxLength={15}
                    defaultValue={formData?.sectorNo}
                    type="textInput"
                    disabled={isEmployee}
                  />
                </Col>
                <Col>
                  <InputWrapper
                    label={t("Khasra No.")}
                    control={control}
                    placeholder={t("Enter Khasra No.")}
                    name="khasraNo"
                    maxLength={15}
                    defaultValue={formData?.khasraNo}
                    type="textInput"
                    disabled={isEmployee}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <InputWrapper
                    label={t("Plot No")}
                    control={control}
                    placeholder={t("Enter Plot no")}
                    name="plotNo"
                    mandatory
                    defaultValue={formData?.plotNo}
                    type="textInput"
                    disabled={isEmployee}
                  />
                </Col>
                <Col></Col>
              </Row>
              <Row>
                <Col>
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={6}>
                      <strong>Drawing PDF</strong>:
                    </Grid>{" "}
                    {/* Label part */}
                    <Grid item xs={6}>
                      {dwgPdf ? (
                        <FaFilePdf
                          color="#a10505"
                          style={{ width: "20px", height: "30px" }}
                          onClick={() => getDocumentByFileStoreId(dwgPdf, setIsPreviewLoading)}
                        />
                      ) : (
                        <FaFilePdf color="#d3d3d3" style={{ width: "20px", height: "30px" }} />
                      )}
                    </Grid>
                  </Grid>
                </Col>
                <Col className="custom-upload new-custom-uploader">
                  <FileUploader
                    isMandatory
                    label={t("Declaration")}
                    control={control}
                    name="declaration"
                    validationMsg="(pdf file only and Max file Size 30 MB)"
                    required
                  />
                </Col>
              </Row>
            </Container>
          </div>

          <div className="formContainer">
            <div className="formHeaderContainer">
              <h2 className="formHeading">{t("Document")}</h2>
            </div>
            <Container fluid className="formInputContainer common-app-form">
              <Row>
                <Col className="custom-upload new-custom-uploader">
                  <FileUploader
                    isMandatory
                    label={t("Document")}
                    control={control}
                    name="document"
                    validationMsg="(pdf file only and Max file Size 30 MB)"
                    required
                  />
                </Col>
                <Col></Col>
              </Row>
            </Container>
          </div>

          <div className="formContainer">
            <div className="formHeaderContainer">
              <h2 className="formHeading">{t("Remark")}</h2>
            </div>
            <Container fluid className="formInputContainer common-app-form">
              {!isEmployee ? (
                <Row>
                  <RemarksEditor setRemarks={setRemarks} remarks={remarks} setError={setError} error={error} />
                </Row>
              ) : (
                <Row>LTP Remark: {formData?.khasraRemarks}</Row>
              )}
            </Container>
          </div>
          <div
            style={{
              margin: "20px",
              padding: "12px 16px",
              backgroundColor: "#fff3cd",
              border: "1px solid #ffeeba",
              borderRadius: "4px",
              color: "#856404",
              fontWeight: "500",
            }}
          >
            {t("FASTPAS.GLOBAL.ONCE.TEXT")}
          </div>
          <div className="footerContainer">
            <div className="buttonWrapper">
              <ButtonWrapper variant="contained" color="success" size="medium" label="Save" type="submit" sx={{ backgroundColor: "#157CB3" }} />
              {!isEmployee && (
                <ButtonWrapper variant="contained" color="success" size="medium" label="Forward" type="submit" sx={{ backgroundColor: "#157CB3" }} />
              )}
            </div>
          </div>
        </form>
        {showToast && (
          <Toast error={showToast?.error} warning={showToast?.warning} label={t(showToast?.message)} onClose={closeToast} isDleteBtn={true} />
        )}
      </section>
    </section>
  );
};

export default WorkCommencementModule;
